module.exports = __webpack_public_path__ + "static/media/nohash/ico-huya.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/nohash/ico-huya.png
// module id = 324
// module chunks = 3